module.exports = {
  JOINSPLITS_SUPPORT: 2,
  OVERWINTER: 3,
  SAPLING: 4
}
